/**
 * Refusals of an Azimut session, as the platform's backends answer them:
 * RFC 9457 problem+json whose `type` names the refusal (galigeo-azimut ADR-047
 * Amendment 1 § 6 and Amendment 2 § 2). An app branches on the type, never on
 * the status alone, and shows each refusal in its interface.
 */
export const AZIMUT_REFUSAL_TYPES = [
    'session-expired',
    'caller-unauthenticated',
    'caller-not-allowed',
    'subject-not-eligible',
    'product-not-enabled',
    'not-converted',
    'datasource-unavailable',
    'exchange-not-configured',
    'azimut-unreachable',
    'import-not-permitted',
];
const REFUSAL_TYPES = new Set(AZIMUT_REFUSAL_TYPES);
/** The last segment of the problem `type` of a response body, or `null`. */
export function problemType(body) {
    try {
        const type = JSON.parse(body)?.type;
        if (typeof type !== 'string' || !type)
            return null;
        return type.replace(/\/+$/, '').split('/').pop() || null;
    }
    catch {
        return null;
    }
}
/**
 * The refusal carried by an error response, or `null` for any other error.
 * A 401 that survived the token renewal is an expired session, whatever its
 * type.
 */
export function azimutRefusal(status, body) {
    const type = problemType(body);
    if (type && REFUSAL_TYPES.has(type))
        return type;
    if (status === 401)
        return 'session-expired';
    return null;
}
//# sourceMappingURL=azimutRefusal.js.map